let engraveTextInput = document.getElementById("engrave-name-input");
const engraveStyleRadioButtons = document.querySelectorAll('input[name="properties[_engravingStyle]"]');
const errMsgParent= document.querySelector('#text-slick.engrave--input');
const errMsgConatiner= document.querySelector('#engrave--err-text--input');
const stylSlickContent = document.getElementById("style-slick");
const textSlickContent = document.getElementById("text-slick");

const engraveCharacterLimit = (text) => {
    const engraveTextInput = document.getElementById("engrave-name-input");
	const errMsgConatiner= document.querySelector('#engrave--err-text--input');
    const productType = engraveTextInput.getAttribute('data-product-type');
    const selectedStyle = document.querySelector('input[name="properties[_engravingStyle]"]:checked')?.getAttribute('data-font-style');
    // const variant = document.querySelector('input[name="Volume"]:checked').value;
    const variant = engraveTextInput.getAttribute('data-variant-value');
	const engravecharacterlister = document.getElementById("engrave_count");
    const inputValue = text? text.replace(/\s+/g, '') : engraveTextInput.value.replace(/\s+/g, '');
    let font = "lowercase";
    if (/^[A-Z]+$/.test(inputValue)) {
        font = "uppercase"
    } else {
        font = "lowercase";
    }
    const maxLenthValue = `${productType}_${selectedStyle}_${variant}_${font}`;
    const limit = maxLenthValue ? engraveMaxlimit[maxLenthValue] : 8 ;
	engravecharacterlister.innerHTML = limit;
    return limit;
}
engraveCharacterLimit();
let limit;
engraveStyleRadioButtons.forEach(function (radioButton) {
    radioButton.addEventListener('change', function () {
		let inputValue = engraveTextInput.value;
        limit = engraveCharacterLimit();

        const textLength = engraveTextInput.value.length;
        if (textLength > limit) {
			engraveTextInput.maxLength = limit;
			const text = inputValue.slice(0, limit);
            limit = engraveCharacterLimit(text);
            text.length > limit? engraveTextInput.value = text.slice(0, limit): engraveTextInput.value = text;
			const dynamicContent = document.getElementById("engrave-dynamic");
			dynamicContent.innerHTML = engraveTextInput.value;
			errMsgConatiner ? null : errMsgParent.insertAdjacentHTML("afterbegin", "<p id='engrave--err-text--input'>Character limit changed based on the font</p>");

			if(window.innerWidth > 767){
				stylSlickContent.style.display = 'none';
				textSlickContent.style.display = 'block';
			}else{
				const mobileSlider = document.querySelector(".engrave--accordian");
				window.jQuery(mobileSlider).slick('slickGoTo', 1);
			}
		}
    });
});

engraveTextInput.addEventListener("keyup", (e) => {
    const inputValue = engraveTextInput.value; 
    limit = engraveCharacterLimit();
    engraveTextInput.maxLength = limit;
    engraveTextInput.value = inputValue.slice(0, limit);
});
engraveTextInput.addEventListener("click", (e) => {
	const errMsgConatiner= document.querySelector('#engrave--err-text--input');
	errMsgConatiner?.remove();
});